import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

export const GET_GET_ALL_EMPLOYEES_FOR_TASK_LIST = gql`
  query getTaskResponsiblePersons($filter: FilterMemberInput) {
    getTaskResponsiblePersons(filter: $filter) {
      collection {
        _id
        profile {
          displayName
          firstName
          lastName
        }
        employeePersonalInfo {
          status
        }
      }
      totalCount
    }
  }
`;

export const useGetAllEmployeesForTaskList = ({ filter }: { filter?: any } = {}) => {
  const currentCompanyId = useGetCurrentCompanyId();
  const { data, loading } = useQuery(GET_GET_ALL_EMPLOYEES_FOR_TASK_LIST, {
    variables: {
      filter: { companyId: currentCompanyId, ...filter },
    },
    skip: !currentCompanyId,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getTaskResponsiblePersons || {};

  return { loading, employees: collection, totalCount };
};
